import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService } from '../commons/abstract.service';
import { SalesMonitor } from '../models/sales-monitor.model';

@Injectable({ providedIn: 'root' })
export class SalesMonitorService extends AbstractService<SalesMonitor> {

  getURLBase(): string {
    return '/sales-monitor';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: SalesMonitor): void {
    delete obj?._id;
  }

  preUpdate(obj: SalesMonitor): void {
  }

}
